export const Types = {
  ACTIVE: 'chat/ACTIVE'
}

// Reducer

const initialState = [{}]

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Types.ACTIVE:
      return {
        id: action.payload.id,
        title: action.payload.title
      }
    default:
      return state
  }
}

// Action Creators

export function setActiveChat (id, title) {
  return {
    type: Types.ACTIVE,
    payload: {
      id,
      title
    }
  }
}
